import { createRootRoute } from '@tanstack/react-router';
import App from '../App';
import { AppProviders } from '../shared/providers';

const RootComponent = () => (
  <AppProviders>
    <App />
  </AppProviders>
);

export const Route = createRootRoute({
  component: RootComponent,
  notFoundComponent: () => null,
});
